import i18n from "../i18n";
import api from "./api";
import type { IReason, IReasonLabels, TReasonListType } from "./api.types";

export type { IReason, IReasonLabels, TReasonListType } from "./api.types";

// Tab order on the Reasons page.
export const REASON_LIST_TYPES: TReasonListType[] = [
  "customerCancel",
  "partnerCancel",
  "reviewTagOwner",
  "reviewTagUser",
];

const rethrow = (error: any, fallbackKey: string): never => {
  if (error.response && error.response.data) {
    throw new Error(error.response.data.message || i18n.t(fallbackKey));
  }
  throw new Error(i18n.t("serviceErrors.serverError"));
};

export const getReasons = async (listType?: TReasonListType): Promise<IReason[]> => {
  try {
    const response = await api.get("/admins/reasons", { params: { listType } });
    return response.data.data;
  } catch (error: any) {
    return rethrow(error, "serviceErrors.fetchReasons");
  }
};

export const createReason = async (payload: {
  listType: TReasonListType;
  value: string;
  labels: IReasonLabels;
  active?: boolean;
}): Promise<IReason> => {
  try {
    const response = await api.post("/admins/reasons", payload);
    return response.data.data;
  } catch (error: any) {
    return rethrow(error, "serviceErrors.createReason");
  }
};

export const updateReason = async (
  id: string,
  payload: {
    labels?: Partial<Record<keyof IReasonLabels, string | null>>;
    active?: boolean;
    order?: number;
  }
): Promise<IReason> => {
  try {
    const response = await api.patch(`/admins/reasons/${id}`, payload);
    return response.data.data;
  } catch (error: any) {
    return rethrow(error, "serviceErrors.updateReason");
  }
};

export const reorderReasons = async (
  listType: TReasonListType,
  ids: string[]
): Promise<IReason[]> => {
  try {
    const response = await api.put("/admins/reasons/reorder", { listType, ids });
    return response.data.data;
  } catch (error: any) {
    return rethrow(error, "serviceErrors.reorderReasons");
  }
};
